require('../../../corporate-template/js/feature/video-spot.js');